import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { Phone, Mail } from "lucide-react";
import { StatusPicker } from "./Status";
import { LeadNotes } from "./LeadNotes";

const money = (v) => (v == null ? "-" : `$${Number(v).toLocaleString()}`);
const Row = ({ k, v }) => (
  <div className="grid grid-cols-[140px_1fr] gap-3 py-3 border-b border-[#0B281E]/10 text-sm">
    <span className="text-[#52635B]">{k}</span><span className="text-[#1A2621] break-words">{v || "-"}</span>
  </div>
);

export const LeadDetail = ({ lead, onClose, onStatus, saving, onNotes }) => (
  <Sheet open={!!lead} onOpenChange={(o) => !o && onClose()}>
    <SheetContent className="w-full sm:max-w-lg bg-[#FAF8F5] overflow-y-auto" data-testid="lead-detail-sheet" data-lenis-prevent>
      {lead && (
        <>
          <SheetHeader>
            <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#A8701F]">{lead.type} quote</p>
            <SheetTitle className="font-serif-d text-3xl text-[#0B281E] text-left">{lead.name}</SheetTitle>
            <p className="text-xs text-[#52635B] text-left">{new Date(lead.created_at).toLocaleString()}</p>
          </SheetHeader>
          <div className="mt-5 flex gap-2">
            <a href={`tel:${lead.phone}`} data-testid="lead-detail-call" className="inline-flex items-center gap-2 rounded-full bg-[#0B281E] text-[#FAF8F5] px-4 py-2 text-sm"><Phone className="w-4 h-4" /> Call</a>
            <a href={`mailto:${lead.email}`} data-testid="lead-detail-email" className="inline-flex items-center gap-2 rounded-full border border-[#0B281E]/20 px-4 py-2 text-sm"><Mail className="w-4 h-4" /> Email</a>
          </div>
          <div className="mt-6">
            <p className="font-mono-d text-[11px] uppercase tracking-[0.18em] text-[#52635B] mb-2">Status</p>
            <StatusPicker value={lead.status} onChange={(s) => onStatus(lead, s)} disabled={saving} />
          </div>
          <div className="mt-6">
            <Row k="Email" v={lead.email} />
            <Row k="Phone" v={lead.phone} />
            {lead.type === "life" && <>
              <Row k="Age" v={lead.age} /><Row k="Tobacco" v={lead.tobacco} /><Row k="State" v={lead.state} />
              <Row k={lead.amount_type === "monthly_budget" ? "Monthly budget" : "Desired coverage"} v={money(lead.amount)} />
            </>}
            {lead.type === "health" && <>
              <Row k="ZIP code" v={lead.zip_code} />
              <Row k="Tax household size" v={lead.household_size ?? lead.members.length} />
              <Row k="Household income" v={money(lead.household_income)} />
              <Row k="Filing status" v={lead.filing_status} />
              <Row k="Insured" v={<ul className="space-y-1">{lead.members.map((m, i) => <li key={i} className="capitalize">{m.relation} · age {m.age} · {m.tobacco}</li>)}</ul>} />
            </>}
            {lead.type === "general" && <>
              <Row k="State" v={lead.state} /><Row k="Interested in" v={lead.coverage.join(", ")} />
              <Row k="Contact by" v={lead.contact_preference} /><Row k="Message" v={lead.message} />
            </>}
          </div>
          <LeadNotes lead={lead} onChange={(notes) => onNotes(lead, notes)} />
        </>
      )}
    </SheetContent>
  </Sheet>
);
